
import React, { JSX } from 'react'
import { Link } from 'react-router'
import { TERMS_PATH, PRIVACY_PATH } from 'lib/paths'
import {
  SOCIAL_LINKEDIN_URL,
  SOCIAL_INSTAGRAM_URL,
  PUBLIC_CONTACT_URL
} from 'lib/externalLinks'
import instagramSvg from '../images/instagram_icon.svg'
import linkedInSvg from '../images/linkedin_icon.svg'

const instagram = <img alt='instagram' className='size-4' src={instagramSvg} />
const linkedin = <img alt='linkedin' className='size-4' src={linkedInSvg} />
const FOOTER_SOCIALS: Array<{ name: string, href: string, image: JSX.Element }> = [
  { name: 'Instagram', href: SOCIAL_INSTAGRAM_URL, image: instagram },
  { name: 'LinkedIn', href: SOCIAL_LINKEDIN_URL, image: linkedin }
]
const SOCIAL_GLYPH_CLASSES = 'text-dm-text-accent hover:text-dm-text-primary'

const SocialItem = ({ name, href, image }: { name: string, href: string, image: JSX.Element }): JSX.Element => {
  if (href === '') {
    return (
      <span aria-label={name} title={name} className={SOCIAL_GLYPH_CLASSES}>
        {image}
      </span>
    )
  }
  return (
    <a
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      aria-label={name}
      title={name}
      className={SOCIAL_GLYPH_CLASSES}
    >
      {image}
    </a>
  )
}

export const Footer = ({ contactHref = PUBLIC_CONTACT_URL }: { contactHref?: string } = {}): JSX.Element => {
  const year = new Date().getFullYear()

  return (
    <footer data-testid='app-footer' className='mt-auto w-full px-4 py-6'>
      <div className='mx-auto flex max-w-3xl flex-col items-center gap-3'>
        <ul className='flex items-center gap-4'>
          {FOOTER_SOCIALS.map(({ name, href, image }) => (
            <li key={name} className='flex items-center'>
              <SocialItem name={name} href={href} image={image} />
            </li>
          ))}
        </ul>
        <p className='flex flex-wrap items-center justify-center gap-x-1.5 text-[11px] text-dm-text-accent'>
          <span> ©{year} StagePilot, LLC</span>
          <span aria-hidden='true'>·</span>
          {contactHref.startsWith('http')
            ? <a href={contactHref} className='underline hover:text-dm-text-primary'>Contact Us</a>
            : <Link to={contactHref} className='underline hover:text-dm-text-primary'>Contact Us</Link>}
          <span aria-hidden='true'>·</span>
          <Link to={TERMS_PATH} className='underline hover:text-dm-text-primary'>Terms of Service</Link>
          <span aria-hidden='true'>·</span>
          <Link to={PRIVACY_PATH} className='underline hover:text-dm-text-primary'>Privacy Policy</Link>
        </p>
      </div>
    </footer>
  )
}

export default Footer
